import { type ReactNode, type Ref } from 'react'
import classNames from 'classnames/bind'

import styles from './table.module.scss'

/**
 * UI COMPONENTS v2
 *
 * Таблица
 * ------
 * Семантически верная таблица. Родительский элемент (table)
 */

const cx = classNames.bind(styles)

type Props = {
  children: ReactNode
  className?: string
  stripStyles?: boolean
  reference?: Ref<'table' | HTMLTableElement>
  wide?: boolean
  borderTop?: boolean
  borderBottom?: boolean
  border?: boolean
  style?: { [key: string]: string }
}

const Table = ({
  children,
  className,
  stripStyles,
  reference,
  wide,
  borderTop,
  borderBottom,
  border,
  style,
}: Props) => (
  <table
    className={cx({ root: !stripStyles, wide, borderTop, borderBottom, border }, className)}
    ref={reference as Ref<HTMLTableElement>}
    style={style}
  >
    {children}
  </table>
)

export default Table
